import type { AxiosRequestConfig } from 'axios';
import axios from './axios-instance';
import type { ApiResponse } from './models';

export class ApiFactory {
  constructor(private apiUrl: string) {}

  /**
   * 取得單筆資料
   */
  protected getData(...ids: (string | number)[]) {
    const id = ids.filter((value) => value).join('/');
    return axios.get(`${this.apiUrl}/${id}`);
  }

  /**
   * 取得多筆資料
   */
  protected getList(data: any, enableLoading?: boolean) {
    return axios.post(`${this.apiUrl}`, data, {
      headers: {
        enableLoading
      }
    });
  }

  /**
   * 新增資料
   */
  protected create(data: any, config?: AxiosRequestConfig) {
    return axios.post(`${this.apiUrl}`, data, config);
  }

  /**
   * 更新資料
   */
  protected update(data: any, config?: AxiosRequestConfig) {
    return axios.post(`${this.apiUrl}`, data, config);
  }

  /**
   * 刪除資料
   */
  protected delete(data: any): Promise<ApiResponse> {
    return axios.post(`${this.apiUrl}`, data);
  }

  /**
   * 刪除資料
   */
  protected deleteData(url: string, data?: any) {
    return axios.delete(`${this.apiUrl}/${url}`, data);
  }
  /**
   * Get 方法
   */
  protected get<Param, Response = ApiResponse>(
    url: string,
    params?: Param,
    config?: AxiosRequestConfig
  ): Promise<Response> {
    const apiConfig: AxiosRequestConfig = {
      ...config,
      params: { ...config?.params, ...params }
    };

    return axios.get(`${this.apiUrl}/${url}`, apiConfig);
  }

  /**
   * Post 方法
   */
  protected post<Data, Response = ApiResponse>(
    url: string,
    data: Data,
    config?: AxiosRequestConfig
  ): Promise<Response> {
    return axios.post(`${this.apiUrl}/${url}`, data, config);
  }

  /**
   * Post 方法
   */
  protected postNoData<Data, Response = ApiResponse>(
    url: string,
    data?: Data,
    config?: AxiosRequestConfig
  ): Promise<Response> {
    return axios.post(`${this.apiUrl}/${url}`, data, config);
  }

  /**
   * Put 方法
   */
  protected put<Data, Response = ApiResponse>(
    url: string,
    data: Data,
    config?: AxiosRequestConfig
  ): Promise<Response> {
    return axios.put(`${this.apiUrl}/${url}`, data, config);
  }
}
